import type { SVGProps } from 'react';

const SvgCluster = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19 10c-.86 0-1.58.54-1.87 1.3l-1.52.25c-.16-.28-.35-.53-.58-.75l1.21-2.83c.99-.12 1.76-.95 1.76-1.98 0-1.1-.9-2-2-2s-2 .9-2 2c0 .45.15.86.4 1.19l-1.21 2.83c-.06 0-.12-.02-.19-.02-.71 0-1.34.25-1.86.66L6.99 8.06v-.07c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.34 0 .65-.09.93-.24l4.14 2.59a2.8 2.8 0 0 0 .06 1.47l-3.3 2.36c-.25-.11-.53-.18-.82-.18-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.06-.01-.12-.02-.19l3.3-2.36c.49.34 1.08.54 1.72.54.12 0 .24-.02.36-.04l.97 1.94c-.21.32-.33.69-.33 1.1 0 1.1.9 2 2 2s2-.9 2-2-.83-1.92-1.88-1.99l-.97-1.93c.4-.42.68-.96.79-1.56l1.52-.25c.37.44.91.73 1.53.73 1.1 0 2-.9 2-2s-.9-2-2-2z"
    />
  </svg>
);
export default SvgCluster;
